import React from 'react'
import PropTypes from 'prop-types'
//import styled from 'styled-components'

const viewBox = 128
//const logo = "M 124 64 C 124 97.135 97.135 124 64 124 C 30.865 124 4 97.135 4 64 C 4 30.865 30.865 4 64 4 C 97.135 4 124 30.865 124 64 Z M 4 48.84 C 4 48.84 16.05 47.79 18.76 50.04 C 22.275 52.965 27.91 78.54 34.045 78.51 C 40.405 78.48 47.785 48.055 53.825 48.24 C 59.79 48.42 67.96 78.93 74.21 78.81 C 80.65 78.685 88.455 48.51 94.89 48.24 C 101.64 47.955 104.69 77.98 109.575 77.91 C 113.855 77.85 123.66 78.81 123.66 78.81"
const pulse = 'M 9 85.278 C 9 85.278 29.105 87.263 32.626 84.147 C 35.806 81.333 43.335 18.085 47.869 18 C 53.156 17.9 63.13 119.107 68.446 119.2 C 73.851 119.296 83.616 59.513 88.515 59.554 C 93.415 59.595 95.736 80.261 99.439 83.017 C 103.5 86.038 119 84.996 119 84.996'
/*
const CircleWrap = styled.div`
  display: inline-block;
  padding: 6px;
  border: 4px solid ${props => props.strokeColor};
  border-radius: 50%;
`
*/
//border: ${props => props.stroke}px solid ${props => props.strokeColor};
class AnimatedLogo extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      dashlen: 0,
    }
  }

  componentDidMount = () => {
    if (this.props.animation === 'dash') {
      this.setState({ dashlen: this.path.getTotalLength() })
    }
  }

  render() {
    const { animation, size, color, strokeColor } = this.props
    const strokeWidth = 8 //Math.floor(20 * size / viewBox)
    const { dashlen } = this.state
    //console.log('length: '+dashlen+', width: '+strokeWidth)

    return (
        <svg width={size} height={size} viewBox={`0 0 ${viewBox} ${viewBox}`}>
          <path ref={ r => this.path = r } id='animpath' d={pulse} stroke={strokeColor} fill='none' strokeWidth={`${strokeWidth}px`}
            strokeDasharray={`${dashlen} ${dashlen}`}>
            {
              animation === 'dash' &&
              <animate attributeName='stroke-dashoffset' from={dashlen} to={0} dur='2s' repeatCount='indefinite' />
            }
          </path>
          {
            animation === 'circle' &&
            <circle r={strokeWidth * 1.2} cx={0} cy={0} fill={color}>
              <animateMotion repeatCount='indefinite' dur='2s'>
                <mpath xlinkHref='#animpath'/>
              </animateMotion>
            </circle>
          }
        </svg>
    )
  }
}
// <CircleWrap {...this.props} stroke={strokeWidth / 2}>
AnimatedLogo.defaultProps = {
  animation: 'circle',
  color: 'red',
  strokeColor: 'teal',
  size: 48
}

AnimatedLogo.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strokeColor: PropTypes.string,
  animation: PropTypes.oneOf(['circle', 'dash'])
}

export default AnimatedLogo



// WEBPACK FOOTER //
// ./src/components/widgets/AnimatedLogo.js